<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      width="416">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="pt-0 px-8 pb-6 title">
          {{ this.form._id ? 'Editar método de pago' : 'Crear método de pago' }}
        </v-card-title>
        <v-card-text class="px-8 pb-8">
          <v-form v-model="isValid" ref="form">
            <v-row>
              <v-col class="py-0 pb-2" cols="12">
                <div class="d-flex">
                  <v-select
                    rounded
                    outlined
                    dense
                    v-model="form.incomeType"
                    :rules="rules.required"
                    item-text="name"
                    item-value="_id"
                    :items="types"
                    label="Tipo de ingreso"
                  />
                  <div class="pl-3">
                    <v-tooltip top v-if="expensesPermissions['create-income-type']">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          fab
                          color="primary"
                          x-small
                          depressed
                          @click="openAddIncomeTypeDialog()"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar tipo de ingreso</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <!-- <v-col class="py-0" cols="12">
                <div class="d-flex">
                  <v-select
                    rounded
                    outlined
                    dense
                    v-model="form.concept"
                    :rules="rules.required"
                    item-text="name"
                    item-value="_id"
                    :items="filteredConcepts.length ? filteredConcepts : concepts"
                    :label="$t('expenses.incomeCategories.editCategoryDialog.concept')"
                    @change="selectType()"
                  />
                  <div class="pl-3">
                    <v-tooltip top v-if="expensesPermissions['create-outgoing-concept']">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          fab
                          color="primary"
                          x-small
                          depressed
                          @click="openAddOutgoingConceptDialog()"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar concepto de egreso</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col> -->
              <v-col class="py-0" cols="12">
                <EditOutlinedInput
                  v-model="form.name"
                  :rules="rules.required"
                  label="Nombre del método de pago"
                />
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field
                  rounded
                  outlined
                  dense
                  v-model="form.wansoftName"
                  label="Nombre de wansoft"
                  append-icon="mdi-pencil-outline"
                  class="outlinedInput"
                  :rules="rules.spaces"
                />
              </v-col>
              <v-col class="py-0 d-flex justify-space-between px-5" cols="12">
                <v-radio-group
                  v-model="form.needInvoice"
                  :rules="rules.required"
                >
                  <template v-slot:label>
                    <div class="radioTitle">¿Requiere factura?</div>
                  </template>
                  <v-radio
                    label="Sí"
                    value="yes"
                    class="ml-6 radio"
                    color="primary"
                    off-icon="mdi-circle"
                    on-icon="mdi-record-circle"
                  ></v-radio>
                  <v-radio
                    label="No"
                    value="no"
                    class="ml-6 radio"
                    color="primary"
                    off-icon="mdi-circle"
                    on-icon="mdi-record-circle"
                  ></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="form.editableTip"
                  :rules="rules.required"
                >
                  <template v-slot:label>
                    <div class="radioTitle">¿Propina editable?</div>
                  </template>
                  <v-radio
                    label="Sí"
                    value="yes"
                    class="ml-6 radio"
                    color="primary"
                    off-icon="mdi-circle"
                    on-icon="mdi-record-circle"
                  ></v-radio>
                  <v-radio
                    label="No"
                    value="no"
                    class="ml-6 radio"
                    color="primary"
                    off-icon="mdi-circle"
                    on-icon="mdi-record-circle"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between px-10 pb-8">
          <Button size="x-small" type="outlined" @click="closeDialog()">
            {{ $t('expenses.incomeCategories.conceptDialog.buttonCancel') }}
          </Button>
          <Button size="x-small" @click="create()">
            {{ this.form._id ? $t('expenses.incomeCategories.conceptDialog.buttonEdit') : $t('expenses.incomeCategories.conceptDialog.buttonCreate') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddIncomeType
      ref="addType"
      @updated="loadTypes"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddIncomeType from '@/components/modals/AddIncomeType'
import Button from '@/components/elements/Button'
import EditOutlinedInput from '@/components/elements/EditOutlinedInput'

export default {
  components: {
    AddIncomeType,
    Button,
    EditOutlinedInput
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        _id: null,
        type: 'paymentMethod',
        incomeType: null,
        name: null,
        wansoftName: '',
        needInvoice: false,
        editableTip: false
      },
      types: [],
      filteredConcepts: [],

      table: {
        incomeConcepts: {
          loadingText: this.$i18n.t('expenses.incomeCategories.conceptDialog.table.loadingText'),
          loading: false,
          headers: [
            { text: this.$i18n.t('expenses.incomeCategories.conceptDialog.table.headers.type'), value: 'type' },
            { text: this.$i18n.t('expenses.incomeCategories.conceptDialog.table.headers.name'), value: 'name' },
            { text: '', value: 'action' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        }
      },
      rules: {
        required: [v => !!v || `Este campo ${this.$i18n.t('messages.isRequired')}`],
        spaces: [v => (v || '').indexOf(' ') < 0 || `No se aceptan espacios en blanco`]
      }
    }
  },
  computed: {
    expensesPermissions () {
      return this.$store.state.login.permissions['expenses'].components['income-category'].actions
    }
  },
  watch: {
    isOpen: async function (val) {
      if (val) {
        await this.loadTypes()
        await this.loadConcepts()
      }
    }
  },
  methods: {
    openDialog (paymentMethod) {
      if (paymentMethod) {
        const { _id, name, needInvoice, editableTip, wansoftName, incomeType } = paymentMethod
        this.form = {
          _id,
          name,
          incomeType: incomeType,
          wansoftName,
          needInvoice: needInvoice ? 'yes' : needInvoice === false ? 'no' : null,
          editableTip: editableTip ? 'yes' : editableTip === false ? 'no' : null
        }
      }
      this.isOpen = true
    },
    closeDialog () {
      this.isOpen = false
      this.form = {
        _id: null,
        type: null,
        incomeType: null,
        name: null,
        wansoftName: '',
        needInvoice: null,
        editableTip: null
      }
      this.types = []
      this.filteredConcepts = []
      this.concepts = []
      this.$refs.form.resetValidation()
    },
    async create () {
      this.$refs.form.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          const payload = {
            name: this.form.name,
            wansoftName: this.form.wansoftName,
            needInvoice: this.form.needInvoice === 'yes' ? true : this.form.needInvoice === 'no' ? false : undefined,
            editableTip: this.form.editableTip === 'yes' ? true : this.form.editableTip === 'no' ? false : undefined,
            type: 'paymentMethod',
            incomeType: this.form.incomeType,
            restaurant: this.$store.state.currentRestaurant.data._id
          }
          if (this.form._id) {
            await this.$api.put(`/v1/cashflows/${this.form._id}`, payload)
          } else {
            await this.$api.post(`/v1/cashflows`, payload)
          }
          this.loadTypes()
          this.loadConcepts()
          this.$emit('updated')
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async loadConcepts (params = null) {
      params = params || {
        type: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.table.incomeConcepts.loading = true
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/types`, params)
        this.concepts = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.incomeConcepts.loading = false
      this.overlay = false
    },
    async loadTypes (params = null) {
      params = params || {
        kind: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows/types`, params)
        this.types = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openAddIncomeTypeDialog (type) {
      this.$refs.addType.openDialog(type)
    },
    filterConcepts () {
      this.form.concept = null
      this.filteredConcepts = this.concepts.filter(concept => concept.type === this.form.type)
    },
    selectType () {
      const selectedConcept = this.concepts.find(concept => concept._id === this.form.concept)
      this.form.type = selectedConcept.type ? this.types.find(type => type._id === selectedConcept.type) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    font-weight: 500;
    font-size: 22px;
    color: #01D28E;
  }

  .outlinedInput {
    & ::v-deep .v-label {
      top: auto;

      &--active {
        top: 10px !important;
      }
    }

    & ::v-deep .v-input__slot {
      padding-right: 8px !important;
    }

    & ::v-deep .v-input__append-inner {
      margin-top: 4px !important;
    }

    & ::v-deep .v-input__icon--append {
      color: #01D28E;
    }
  }

  .radioTitle {
    font-weight: 500;
    font-size: 14px;
    color: #646464;
  }

  .radio {
    color: #D9DBE9;
  }
</style>
